import React from 'react';
import FilterItem from '../FilterItem/FilterItem';
import DropdownMenu from '../DropdownMenu/DropdownMenu';
import './DateRangeFilter.css';

const DateRangeFilter = ({
    isActive,
    dateRange,
    onToggle,
    onDateChange,
    onClear
}) => {
    const hasDateFilter = dateRange.start || dateRange.end;

    const handleApply = () => {
        onToggle(null);
    };

    return (
        <FilterItem
            label="Date"
            isActive={isActive}
            hasFilters={hasDateFilter}
            count={hasDateFilter ? 1 : 0}
            onToggle={() => onToggle('date')}
        >
            <DropdownMenu
                title="Plage de dates"
                hasSelectedItems={hasDateFilter}
                onClear={() => onClear('dateRange')}
                onApply={handleApply}
            >
                <div className="date-range-container">
                    <div className="date-input-group">
                        <label>Du</label>
                        <input
                            type="date"
                            className="date-input"
                            value={dateRange.start || ""}
                            onChange={(e) => onDateChange('start', e.target.value)}
                        />
                    </div>
                    <div className="date-input-group">
                        <label>Au</label>
                        <input
                            type="date"
                            className="date-input"
                            value={dateRange.end || ""}
                            onChange={(e) => onDateChange('end', e.target.value)}
                        />
                    </div>
                </div>
            </DropdownMenu>
        </FilterItem>
    );
};

export default DateRangeFilter;